export const RELOAD_MAP_DATA_DURATION = 1000 * 120;
export const SHOW_MESSAGE_DURATION = 1000 * 10;
